import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class UniversityFacultyService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                private fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    getByAdmin(universityId): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITY_FACULTY(universityId));
    }

    createByAdmin(universityId, data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_FACULTY(universityId), data);
    }

    deleteByAdmin(universityId, id): Observable<any> {
        return this.deleteRequest(AppUrl.UNIVERSITY_FACULTY_DELETE(universityId, id));
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }
}
